import requests from './httpService';
const CalenderAssignmentService = {
  getAllCalenderAssignment(params = {}) {
    const q = new URLSearchParams(params).toString();
    return requests.get(`/calenderassignment/list${q ? `?${q}` : ''}`);
  },
  getCalenderAssignmentbyId(id) {
    return requests.get(`/calenderassignment/${id}`);
  },
  deleteAzureImage(body){
    return requests.post(`/calenderassignment/deleteazureimage`,body);

  },
  uploadImage(body) {
    return requests.post(`/calenderassignment/uploadimage`,body);
  },
  creteImages(body){
    return requests.post('/image/add',body);
  },
  creteCalenderAssignment(body){
    return requests.post('/calenderassignment/add',body); 
  },
  deleteCalenderAssignment(body){
    return requests.delete(`/calenderassignment/${body._id}`); 
  },
  findCalenderAssignmentList(body){
    return requests.post(`/calenderassignment/find`,body); 
  },

  upadeCalenderAssignment(body) {
    return requests.put(`/calenderassignment/${body._id}`,body); 
  },

};
export default CalenderAssignmentService;
